<template>
  <div class="video-player-container">
    <loading-indicator v-if="fetchingIframeUrl" />
    <template v-else>
      <iframe
        v-if="cloudflareIframeUrl"
        ref="iframe"
        :src="cloudflarePlayerSrc"
        allow="accelerometer; gyroscope; autoplay; encrypted-media;"
        allowfullscreen="true"
        @load="onLoad"
      />
      <jw-player v-else :video="video" />
    </template>
  </div>
</template>

<script>
import * as fileApi from "@/api/fileApi.js"

import JwPlayer from "@/components/files/JwPlayer.vue"

export default {
  components: {
    JwPlayer
  },
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      played: false,
      cloudflareIframeUrl: null,
      fetchingIframeUrl: false
    }
  },
  computed: {
    cloudflarePlayerSrc() {
      if (!this.cloudflareIframeUrl) {
        return null
      }

      if (this.video.thumbnail_url) {
        return `${this.cloudflareIframeUrl}?poster=${encodeURIComponent(this.video.thumbnail_url)}`
      }
      return this.cloudflareIframeUrl
    }
  },
  created() {
    if (this.video.provider === "cloudflare") {
      this.fetchVideoIframeUrl()
    }
  },
  methods: {
    onLoad() {
      try {
        const player = window.Stream(this.$refs.iframe)
        player.addEventListener("play", () => {
          if (this.played) {
            return
          }
          this.played = true
          this.registerVideoPlay()
        })
      } catch (err) {
        this.$reportError(err)
      }
    },
    async fetchVideoIframeUrl() {
      try {
        this.fetchingIframeUrl = true
        const { url } = await fileApi.getVideoIframeUrl(this.video.id)
        this.cloudflareIframeUrl = url
      } catch (err) {
        this.$reportError(err)
      } finally {
        this.fetchingIframeUrl = false
      }
    },
    async registerVideoPlay() {
      try {
        await fileApi.registerVideoPlay(this.video.id)
      } catch (err) {
        this.$reportError(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  border: none;
}

.loader-container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
